export const FETCH_TEST_SUCCESS = 'FETCH_TEST_SUCCESS';


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js